/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */
import Topbar from './index';
import Section from './section';
import Items from './items';
import Item from './item';

/**
 * Style dependencies
 */
import './styles.scss';
import logo from 'assets/images/tower_logo_white.png';

const LoggedInTopbar = (props) => {
    return (
        <Topbar>
            <div className='topbar__sales-details'>
                <Section>
                    <Items>
                        <Item className='active' label={<label><a href="//www.towersystems.com.au/how-can-we-help-you.html">SALES:</a> 1300 662 957</label>} />
                        <Item className='active' label={<label><a href="//www.towersystems.com.au/help.html">SUPPORT:</a> +61 3 9524 8000</label>} />
                        <Item className='disabled' label='support@towersystems.com.au' />
                    </Items>
                </Section>
                <Section>
                    <Items>
                        <Item path="//www.towersystems.com.au" label='' icon={{ name: 'FiHome' }} />
                        <Item path="/logout" label='Sign Out' />
                        <Item path="//www.towersystems.com.au/help.html" label='Help' />
                        <Item path="//blog.towersystems.com.au" label='Blog' />
                    </Items>
                </Section>
            </div>
            <div className='p-4 d-flex align-items-center'>
                <img src={logo} alt='towersystems' />
                <h3 className='pl-3 topbar__heading'>Billing</h3>
            </div>
        </Topbar>
    );
};

export default LoggedInTopbar;
